const FaqExpandedQuestion = ({ content, isExpanded }) => {
    return (
        <div className={isExpanded ? 'expanded showed' : 'expanded hidden'}>
            <div> {content} </div>
        </div>
    )
}
export default FaqExpandedQuestion
